import React from 'react';
import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';
import HighlightedSuggestionText from './TypeaheadHighlightedSuggestionText';

class TypeaheadSuggestionItem extends React.Component {
  render() {
    const { searchText, suggestion, getSuggestionText } = this.props;

    const escapedSearchText = searchText ? searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : '';
    const re = new RegExp(`(${escapedSearchText})`, 'i');
    return reactStringReplace(getSuggestionText(suggestion), re, HighlightedSuggestionText);
  }
}

TypeaheadSuggestionItem.propTypes = {
  searchText: PropTypes.string,
  suggestion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string.isRequired,
    }),
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]).isRequired,
  getSuggestionText: PropTypes.func.isRequired,
};

export default TypeaheadSuggestionItem;
